import './style.css'

import PropTypes from 'prop-types'

import React from 'react'
import classNames from 'classnames'

import { CloseIcon } from 'components/Utils/Icons'

function BannerBase({
  warning = false,
  debug = false,
  small = false,
  children,
  closable,
  onClose,
  style,
}) {
  const className = classNames(
    'banner',
    'padding-horizontal-normal width-full zindex-mega flexbox shade-100 transition',
    {
      'banner--small': small,
      'background-stripped-red': warning,
      'banner--debug': debug,
      'background-stripped-purple': !warning && !debug,
    }
  )
  return (
    <div className={className} style={style}>
      <div className="flexbox-grow">{children}</div>
      {closable && (
        <button
          className="banner-close shade-100 margin-left-auto margin-right-small"
          onClick={onClose}
        >
          <CloseIcon size={16} />
        </button>
      )}
    </div>
  )
}

BannerBase.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default BannerBase
